import React from "react";

import { BlueprintIcon, BlueprintIconProps } from "../blueprint-icon";

export const CheckCircle: React.FC<BlueprintIconProps> = (props) => (
  <BlueprintIcon viewBox="0 0 16 16" {...props}>
    <circle cx="8" cy="8" r="8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8995 5.53553L11.4853 4.12132L6.53559 9.07107L4.41427 6.94975L3.00005 8.36396L5.12137 10.4853L6.53559 11.8995L7.9498 10.4853L12.8995 5.53553Z"
      fill="white"
    />
  </BlueprintIcon>
);
